angular.module('app.player.linesController', [])
  .controller('app.player.linesController', [
    '$scope',
    function ($scope) {
      "use strict";

      $scope.isSavingLines = 0;

      let extractLinesData = function (lines) {

        let linesToSave = [];

        for (let team in lines) {
          if (lines.hasOwnProperty(team)) {
            if (typeof lines[team] === 'object' && lines[team] !== null) {

              for (let line in lines[team]) {
                if (lines[team].hasOwnProperty(line)) {
                  let hasData = false;

                  let tempLine = {
                    igameid: lines.igameid,
                    iteamid: lines[team].iteamid,
                    linenumber: line,
                    data: {}
                  };

                  if (typeof lines[team][line] === 'object') {
                    for (let pos in lines[team][line]) {
                      if (lines[team][line].hasOwnProperty(pos)) {
                        // To save only non-null values, use this if statement.
                        // Turned off because have to save blanks when user
                        // deletes a value.

                        // if (lines[team][line][pos] != null) {
                        hasData = true;
                        tempLine.data[pos] = lines[team][line][pos];
                        // }
                      }
                    }
                  }

                  if (hasData) {
                    linesToSave.push(tempLine);
                  }
                }
              }
            }
          }
        }

        return linesToSave;
      };

      let saveLinesLoop = function (lines) {

        let linesToSave = extractLinesData(lines);

        $scope.isSavingLines = linesToSave.length;

        for (let i = 0; i < linesToSave.length; i++) {
          //noinspection JSValidateTypes
          $scope.game.saveLine(linesToSave[i].igameid, linesToSave[i].iteamid, linesToSave[i].linenumber, linesToSave[i].data, function () {
            $scope.isSavingLines--;
          });
        }
      };

      $scope.linesSaveClick = function () {
        saveLinesLoop($scope.linesNumbers);
        $scope.linesForm.$setPristine();
      };

      $scope.linesNumbers = {};

      let populateLines = function () {

        for (let key in $scope.game.data.lineup) {
          if ($scope.game.data.lineup.hasOwnProperty(key)) {
            if (key == $scope.game.data.awayteam.iteamid) {
              $scope.linesNumbers.away = $scope.game.data.lineup[key];
              $scope.linesNumbers.away.iteamid = key;

            } else if (key == $scope.game.data.hometeam.iteamid) {
              $scope.linesNumbers.home = $scope.game.data.lineup[key];
              $scope.linesNumbers.home.iteamid = key;
            }
          }
        }

        $scope.linesNumbers.igameid = $scope.game.data.igameid;
      };

      let loadRoster = function (max, count) {

        let loadStart = false;

        if (typeof count === 'undefined') {
          count = 0;
        } else {
          count++;
        }

        if (count <= max && !loadStart) {
          window.setTimeout(function () {

            if ($scope.game.data) {
              loadStart = true;

              $scope.roster.retrieve($scope.game.data.igameid, populateLines);
            } else {
              loadRoster(max, count);
            }

          }, 100);
        }
      };

      let init = function () {
        loadRoster(20, 0);
      };

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/player/lines/linesController.js